import { withInstall } from '@jdesign-vue/utils'

import Alert from './src/alert.vue'

export const JdAlert = withInstall(Alert)
export default JdAlert

export * from './src/alert'
export type { AlertInstance } from './src/instance'
